<template>
  <date-picker
    :editable="editable"
    :disabled="disabled"
    :input-name="name"
    :value="value"
    v-on:input="onInput($event)"
    :lang="lang"
    type="datetime"
    :format="format"
    :minute-step="parseInt(minuteStep)"
    :input-class="inputClass"
  ></date-picker>
</template>

<script>
  import DatePicker from 'vue2-datepicker'

  export default {
    components: {
      DatePicker
    },
    props: {
      format: {
        type: String,
        default: 'YYYY-MM-DD HH:mm',
      },
      editable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: 'date'
      },
      range: {
        type: Boolean,
        default: false
      },
      value: null,
      inputClass: {
        type: [String, Array],
        default: 'mx-input'
      },
      placeholderDate: {
        type: String,
        default: null
      },
      placeholderDateRange: {
        type: String,
        default: null
      },
      width: {
        type: [String, Number],
        default: null
      },
      minuteStep: {
        type: [String, Number],
        default: 10
      },
    },
    data() {
      return {
        lang: {
          days: ['日', '月', '火', '水', '木', '金', '土'],
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
          placeholder: {
            date: this.placeholderDate ? this.placeholderDate : '日付を選択してください',
            dateRange: this.placeholderDateRange ? this.placeholderDateRange : '日付範囲を選択してください',
          }
        }
      }
    },
    created() {
      this.onInput(this.value)
    },
    methods: {
      formatByMinuteStep(value) {
        // 強制的にminuteStep単位にする
        let dt = moment(value)
        if (dt.isValid()) {
          let minute = Math.floor(dt.minute() / this.minuteStep) * this.minuteStep
          value = dt.minute(minute)
        }

        return value;
      },
      onInput(value) {
        value = this.formatByMinuteStep(value);
        this.$emit('input', value)
      }
    }
  }
</script>
